import * as React from "react";
import { useNavigate } from "react-router";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import url from "src/config/search.json";
import styles from "src/components/UI/LeftCard/assets/scss/Menu.module.scss";
import { _GetTitle, _GetType } from "src/components/UI/Shared/handler";
import {
  FreeIcon,
  PremiumIcon,
  MixedIcon,
} from "src/components/UI/LeftCard/icons";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";

const keys = Object.keys(url.services);
const currentkey = keys[1];
interface ControlledOpenSelect2Props {}

const ControlledOpenSelect2 = ({}: ControlledOpenSelect2Props) => {
  const dispatch = useDispatch();
  const searchString = useSelector((state: any) => state.app.searchString);
  const navigate = useNavigate();

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const Icon = (category: number, item: number) => {
    const type = _GetType(category, item);
    if (type === "free") return <FreeIcon />;
    else if (type === "premium") return <PremiumIcon />;
    return <MixedIcon />;
  };
  const handleChange = (event: SelectChangeEvent) => {
    dispatch(
      appActions.setSearchString({
        ...searchString,
        menu2: event.target.value,
      })
    );
  };
  const handleGoToSearchString = (choosen: string) => {
    if (choosen === "kml-conversion") {
      navigate(`${currentkey}/${url.services.Conversion[0].url}`);
    } else if (choosen === "shp-conversion") {
      navigate(`${currentkey}/${url.services.Conversion[1].url}`);
    } else if (choosen === "geojson-conversion") {
      navigate(`${currentkey}/${url.services.Conversion[2].url}`);
    } else if (choosen === "autocad-conversion") {
      navigate(`${currentkey}/${url.services.Conversion[3].url}`);
    } else if (choosen === "fgdb-conversion") {
      navigate(`${currentkey}/${url.services.Conversion[4].url}`);
    } else if (choosen === "Converter") {
      navigate(`${currentkey}/${url.services.Conversion[6].url}`);
    }
  };

  React.useEffect(() => {
    handleGoToSearchString(searchString.menu2);
  }, [searchString]);
  return (
    <div>
      <FormControl sx={{ m: 1, minWidth: 120, margin: "0.75rem 0" }}>
        <InputLabel
          id="demo-controlled-open-select-label"
          className={styles.label}
        >
          Conversion
        </InputLabel>
        <Select
          labelId="demo-controlled-open-select-label"
          id="demo-controlled-open-select"
          className={styles.select}
          open={open}
          onClose={handleClose}
          onOpen={handleOpen}
          value={searchString.menu2}
          onChange={handleChange}
          label="selectValue"
        >
          <MenuItem className={styles.menuItem} value={"kml-conversion"}>
            {_GetTitle(1, 0)}
            {Icon(1, 0)}
          </MenuItem>
          <MenuItem className={styles.menuItem} value={"shp-conversion"}>
            {_GetTitle(1, 1)}
            {Icon(1, 1)}
          </MenuItem>
          <MenuItem className={styles.menuItem} value={"geojson-conversion"}>
            {_GetTitle(1, 2)}
            {Icon(1, 2)}
          </MenuItem>
          <MenuItem className={styles.menuItem} value={"autocad-conversion"}>
            {_GetTitle(1, 3)}
            {Icon(1, 3)}
          </MenuItem>
          <MenuItem className={styles.menuItem} value={"fgdb-conversion"}>
            {_GetTitle(1, 4)}
            {Icon(1, 4)}
          </MenuItem>
          {/* <MenuItem className={styles.menuItem} value={"pdf-conversion"}>
            {_GetTitle(1, 4)}
            {Icon(1, 4)}
          </MenuItem> */}
          <MenuItem className={styles.menuItem} value={"Converter"}>
            {_GetTitle(1, 6)}
            {Icon(1, 6)}
          </MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default ControlledOpenSelect2;
